<div class="auth-signin-register d-flex justify-content-center align-items-center" style="height: 100%;">
    <!-- Left Panel -->
    <div class="auth-form-container col-md-6 d-flex flex-column justify-content-center align-items-center">
        <div *ngIf="isSignInRoute && shouldAllowLogin" #formCard class="form-card">
            <div class="form-header">
                {{finalResources.signInHeaderMessage}}
            </div>
            <div class="form-text">
                {{finalResources.signInTextMessage }}
            </div>
            <br>
            <div #formContent class="form-content">
                <div class="otp-component-container">
                    <app-otp [allowEmail]="(clientInfo && clientInfo.LoginMethodsAllowed.EmailOTP) || false"
                        [allowMobile]="(clientInfo && clientInfo.LoginMethodsAllowed.MobileOTP) || false"></app-otp>
                </div>
                <div class="google-component-container"
                    *ngIf="clientInfo && clientInfo.LoginMethodsAllowed.Gmail && clientInfo?.ClientId && clientInfo?.Scopes">
                    <app-google [loginHint]="loginHint" [clientId]="clientInfo?.ClientId!"
                        [scopes]="clientInfo?.Scopes!" [showWarningAndErrors]="true"
                        (successCallBack)="onGoogleLoginSuccess($event)"
                        (failureCallBack)="onGoogleLoginFailure($event)">
                    </app-google>
                </div>
                <div class="apple-component-container" *ngIf="allowAppleSignIn">
                    <app-apple-signin [clientId]="appleClientId" [showWarningAndErrors]="true"
                        (successCallBack)="onAppleSuccess($event)" (failureCallBack)="onAppleFailure($event)" />
                </div>
            </div>
        </div>

        <div *ngIf="isRegisterRoute && shouldAllowLogin" class="register-container">
            <app-register [formData]="registerFormData"
                [allowEmail]="(clientInfo && clientInfo.LoginMethodsAllowed.EmailOTP) || false"
                [allowMobile]="(clientInfo && clientInfo.LoginMethodsAllowed.MobileOTP) || false"
                (formSubmitted)="handleRegisterFormSubmit($event)"></app-register>
        </div>

        <!-- Region Not Supported Container -->
        <div *ngIf="!shouldAllowLogin" class="region-not-allowed-container">
            <div class="inner-content">
                <span class="material-symbols-outlined">block</span>
                <span>We're sorry, but this application isn't supported in your region right now.</span>
            </div>
        </div>
    </div>


    <!-- Right Panel -->
    <div class="logo-container col-md-6 d-none d-md-flex justify-content-center align-items-center">
        <div class="app-logo"></div>
    </div>
</div>